export default [
  {
    title: 'Dashboard',
    route: 'clinician-dashboard',
    icon: 'HomeIcon',
  },
]
